import { z } from 'zod';
import type { SchemaErrors } from './SchemaErrors';
import { optionalNumber } from './OptionalNumber';

export const owner = z.object({
  id: z.number().positive(),
  fullName: z.string().nonempty(),
  userId: z.string().nonempty().optional(),
  officeId: optionalNumber(),
  isActive: z.boolean().optional(),
});

const userRoleValues = [
  'Account Exec',
  'Business Manager',
  'Coordinator',
  'General Manager',
  'Graphic Designer',
  'Marketplace Manager',
  'Marketplace Signer',
  'Operations Manager',
  'Production Coordinator',
  'Real Estate Manager',
  'Sales Manager',
  'Technologist',
] as const;

export const UserRoles = z.enum(userRoleValues);

export type OwnerSchema = z.infer<typeof owner>;
export type User = Required<OwnerSchema>;
export type UserRole = z.infer<typeof UserRoles>;
export type OwnerValidationErrors = SchemaErrors<OwnerSchema>;
